export const getPathWithoutLocale = (path: string) => {
  return path.replace('/[locale]', '');
};
